import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import configureStore from 'configureStore'
import { HashRouter } from 'react-router-dom'
import buildUrl from '../utils/apiHelpers'
import MyListingsContainer from 'containers/MyListingsContainer'

const store = configureStore()

class MyListingsRoot extends React.Component {
  render () {
    // Preserve the "view as seller" context (admins only) when navigating to
    // the Imported URLs page, which uses the `id` query string convention.
    const importedUrlsPath = this.props.sellerId
      ? `/submitted_urls/my_submitted_urls?id=${this.props.sellerId}`
      : '/submitted_urls/my_submitted_urls'

    return (
      <div className='max-w-[1320px] mb-64'>
        <div className='flex mt-24'>
          <div className='text-midnight-black font-semibold px-16 pb-10 mr-30 border-b-4 border-midnight-black'> Listings </div>
          {!this.props.p2pSeller && <a className='text-midnight-black-80 font-light pb-10 px-16' href={buildUrl(importedUrlsPath)}> Imported URLs </a>}
        </div>
        <hr className='border-0 mt-0 h-px bg-midnight-black-20 [@media(max-width:400px)]:mb-16' />
        <Provider store={store}>
          <HashRouter>
            <MyListingsContainer
              p2pSeller={this.props.p2pSeller}
              canBoostListings={this.props.canBoostListings}
              sellerId={this.props.sellerId}
            />
          </HashRouter>
        </Provider>
      </div>
    )
  }
}

MyListingsRoot.propTypes = {
  p2pSeller: PropTypes.bool,
  canBoostListings: PropTypes.bool,
  sellerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default MyListingsRoot
